import type { IconData } from '@stacksjs/iconify-core'

export const library: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M472 16H168a24 24 0 0 0-24 24v304a24 24 0 0 0 24 24h304a24 24 0 0 0 24-24V40a24 24 0 0 0-24-24m-8 320H176V48h288Z\"/><path fill=\"currentColor\" d=\"M112 400V80H80v328a24 24 0 0 0 24 24h328v-32Z\"/><path fill=\"currentColor\" d=\"M48 464V144H16v328a24 24 0 0 0 24 24h328v-32Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default library
